import React from 'react';
import { Modal } from 'react-bootstrap';
import { FaLayerGroup } from 'react-icons/fa';
import './GuideModal.scss';

interface GuideModalProps {
  show: boolean;
  onClose: () => void;
}

const GuideModal: React.FC<GuideModalProps> = ({ show, onClose }) => {
  return (
    <Modal show={show} onHide={onClose} centered dialogClassName="selection-guide-modal" contentClassName="selection-guide-content">
      <Modal.Header className="guide-header minimalist">
        <div className="guide-heading">
          <span className="guide-icon"><FaLayerGroup /></span>
          <div className="guide-titles">
            <Modal.Title>Guía: Combos y Extras</Modal.Title>
          </div>
        </div>
      </Modal.Header>
      <Modal.Body className="guide-body">
        <ol className="guide-steps">
          <li className="guide-step">
            <div className="step-badge">1</div>
            <div className="step-text">
              <h5>Crea un grupo</h5>
              <p>Dale un nombre simple y directo. Ej: <strong>Acompañamientos Burger</strong>, <strong>Salsas de Alitas</strong>, <strong>Bebidas del Combo</strong>.</p>
            </div>
          </li>
          <li className="guide-step">
            <div className="step-badge">2</div>
            <div className="step-text">
              <h5>Agrega productos reales</h5>
              <p>Incluye ítems que existen en tu inventario o menú (cosas que se preparan, se sirven o tienen costo). No agregues aquí estados como <em>caliente / frío</em> o <em>con / sin hielo</em>.</p>
              <div className="mini-hint">Tip: Máximo 5‑7 opciones mantiene la elección fácil.</div>
            </div>
          </li>
          <li className="guide-step">
            <div className="step-badge">3</div>
            <div className="step-text">
              <h5>Vincula el grupo</h5>
              <p>Asocia el grupo a los productos donde el cliente puede elegir esas opciones. Puedes reutilizar el mismo grupo en muchos productos.</p>
            </div>
          </li>
        </ol>

        <div className="examples-grid">
          <div className="example-card">
            <span className="example-label">Hamburguesa</span>
            <p>Papas chicas, Papas medianas, Aros de cebolla.</p>
          </div>
          <div className="example-card">
            <span className="example-label">Pizza</span>
            <p>Extra queso, Pepperoni extra, Champiñones.</p>
          </div>
          <div className="example-card">
            <span className="example-label">Combo bebida</span>
            <p>Refresco lata, Refresco 600ml, Agua, Jugo.</p>
          </div>
          <div className="example-card">
            <span className="example-label">Tazón</span>
            <p>Proteína pollo, Proteína res, Proteína tofu.</p>
          </div>
        </div>

        <div className="pro-tips">
          <h6>Importante</h6>
          <ul>
            <li><span><strong>Solo</strong> agrupa productos físicos o con costo.</span></li>
            <li><span>Opciones como caliente/frío, término de cocción o azúcar/hielo van en un <strong>Grupo Modificador</strong> (no consumen stock). <a href="/App/SelectionModifiers" className="inline-link">Ver Grupos Modificadores</a></span></li>
            <li><span>Nombres cortos y claros ayudan a todos.</span></li>
            <li><span>Evita listas largas: claridad vende más.</span></li>
            <li><span>Reutiliza grupos para mantener consistencia.</span></li>
          </ul>
        </div>

        <div className="scope-note" aria-label="Nota aclaratoria">
          <strong>¿Duda rápida?</strong> Si la opción solo cambia el estado del producto (temperatura, término, con/sin hielo) y no es un ítem que se venda solo, <strong>no</strong> es un Grupo: es un <strong>Grupo Modificador</strong>. 
          <a href="/App/SelectionModifiers" className="inline-link">Ir a Grupos Modificadores</a>
        </div>
      </Modal.Body>
      <Modal.Footer className="guide-footer">
        <button className="close-btn" onClick={onClose}>Entendido</button>
      </Modal.Footer>
    </Modal>
  );
};

export default GuideModal;
